module.exports = __webpack_public_path__ + "assets/img/bg.b394412f.png";